// tslint:disable
/**
 * Speedtest Plus API
 * This is the API for Speedtest Plus
 *
 * The version of the OpenAPI document: 0.28.0
 * Contact: speedtest-api@anw.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface ConnectionModel
 */
export interface ConnectionModel {
    /**
     * The ipv4 or ipv6 address of the client.
     * @type {string}
     * @memberof ConnectionModel
     */
    ip: string;
    /**
     * Version of the IP address.
     * @type {string}
     * @memberof ConnectionModel
     */
    ipVersion: ConnectionModelIpVersionEnum;
    /**
     * The remote port used for this connection.
     * @type {number}
     * @memberof ConnectionModel
     */
    remotePort?: number | null;
    /**
     * Name of the Internet Service Provider.
     * @type {string}
     * @memberof ConnectionModel
     */
    isp?: string | null;
    /**
     * True, if user is recognized as customer.
     * @type {boolean}
     * @memberof ConnectionModel
     */
    isCustomer?: boolean | null;
    /**
     * Type of internal Vodafone network. UM - UnityMedia, VF - Vodafone
     * @type {string}
     * @memberof ConnectionModel
     */
    ispFootprint?: ConnectionModelIspFootprintEnum;
    /**
     * True, if VPN was detected, false if there is no VPN, otherwise null
     * @type {boolean}
     * @memberof ConnectionModel
     */
    isVpnActive?: boolean | null;
    /**
     * Method that was used to detect the VPN.
     * @type {string}
     * @memberof ConnectionModel
     */
    vpnDetectdBy?: ConnectionModelVpnDetectdByEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum ConnectionModelIpVersionEnum {
    V4 = 'v4',
    V6 = 'v6'
}
/**
 * @export
 * @enum {string}
 */
export enum ConnectionModelIspFootprintEnum {
    Um = 'UM',
    Vf = 'VF'
}
/**
 * @export
 * @enum {string}
 */
export enum ConnectionModelVpnDetectdByEnum {
    Customer = 'customer',
    Ip = 'ip',
    Isp = 'isp',
    Ext = 'ext'
}

